<template>
    <div class="d-flex all-after-header-box">

        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large-xl' : (!drawerLeftMenuMini), 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover, 'drawer-menu-hover-xl' :  drawerLeftMenuHover}"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >
                 <!--
                <template v-if="true">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                </template>

                <v-divider class="mr-2 ml-2"></v-divider>
                -->   
                <!-- @item-selected="handleItemSelected" -->
                <context-tree-view
                    :dataSource="dataSource"
                    :itemClick="itemClick"
                />

               
            </v-navigation-drawer>
        </div>

        <div class="content-box">
            <router-view :key="$route.fullPath" />
        </div>

        <!-- <CreateModal ref="CreateModalRef"/>
        <CreateBoardModal ref="CreateBoardModalRef"/> -->

    </div>
</template>

<script>
// import { httpAPI } from "@/api/httpAPI";
import { mapGetters, mapActions } from 'vuex';

// import CreateModal from '@/components/planner/dialogs/CreateDlg.vue';
// import CreateBoardModal from '@/components/planner/dialogs/CreateBoardDlg.vue';

import ContextTreeView from '@/components/sep/ContextTreeView.vue';

export default {
    name: "SEPMain",
    components: {
        ContextTreeView
        // CreateModal,
        // CreateBoardModal
    },
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        ...mapGetters('sep', { menuLoading: 'isMenuLoading', dataSource: 'getDataSource', classifierId: 'getClassifierId' }),
        // identifier: {
        //     get: function() {
        //         return this.$store.getters['planner/getId'];
        //     },
        //     set: function(v) {
        //         this.$store.commit('planner/SET_ID', v);
        //         this.$store.commit('planner/SET_MENU_ITEM_NAME', this.getLeftMenuItemNameById(v));
        //         this.UpdateCounter();
        //     }
        // },
    },
    data() {
        return {
            drawerLeftMenu: true,
            drawerLeftMenuHover: false,
            /*group1: {
                active: true
            },
            group2: {
                active: false
            },
            group3: {
                active: false
            },
            menuItems: [],
            */
        }
    },
    methods: {
        ...mapActions('sep',  { getDataSource: 'getContexts' }),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        async onCreateClicked() {
            // try
            // {
            //     let { params } = await this.$refs.CreateModalRef.open();

            //     if (params.createType == "None.PlannedMeetingBoard") {
            //         let interaction = await this.$refs.CreateBoardModalRef.open({ new: true });
                    
            //         if (interaction.delete)
            //             return;

            //         let newBoardResponse = await httpAPI({
            //             url: `api/actions/new?type=None.PlannedMeetingBoard`,
            //             method: 'GET'
            //         });

            //         if (newBoardResponse) {
            //             let newBoard = newBoardResponse.data.Payload.Data.Object;
            //             newBoard.Name = interaction.name;

            //             let saveNewBoardResponse = await httpAPI({
            //                 url: `api/actions/save?type=None.PlannedMeetingBoard`,
            //                 method: 'POST',
            //                 headers: { 'Content-Type': 'application/json' },
            //                 data: { Content : JSON.stringify({ parent: newBoard, childrens: null }) }
            //             });

            //             if (saveNewBoardResponse) {
            //                 await this.updateMenuItems();
            //                 this.$eventBus.$emit('planner-boards-changed');
            //             }
            //         }

            //         return;
            //     }

            //     this.$store.commit('planner/SET_CREATION_BAG', null);
            //     await this.loadDataSource({ createType: params.createType, navigate: true, common: params.isCommon ?? false });
            // }
            // catch (ex)
            // {
            //     console.log(ex);
            // }
        },
        async updateMenuItems() {
            this.$store.commit('sep/SET_MENU_LOADING', true);
           
            //TODO load menuItems

            // this.menuItems = tmpItems;
            this.$store.commit('sep/SET_MENU_LOADING', false);
        },
        /*closeOtherGroups(groupName) {
            if (groupName === 'group1') {
                this.group2.active = false;
                this.group3.active = false;
            } else if (groupName === 'group2') {
                this.group1.active = false;
                this.group3.active = false;
            }else if (groupName === 'group3') {
                this.group1.active = false;
                this.group2.active = false;
            }
        },*/
        itemClick(item, type) {
            //console.log(type, item);
            if (type === 'classifier') {
                this.$router.push({ 
                    name: 'DynamicTable', 
                    params: { id: item.Id } 
                });
            }
        }
    },
    beforeMount() {
        this.getDataSource();
    },
    mounted() {
        let selectedId = this.$store.getters['sep/dynamictable/getClassifierId']
        if (selectedId){
            this.itemClick('classifier', {Id: selectedId});
        }
    }
}
</script>